import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'
import workflowLoaded from '../workflowLoaded'

const postWorkflow = ({ params }) =>
  HttpClient().post('/api/v1/workflow', { data: params.data })

const createWorkflow =
  ({ attachmentId, contentAccountId, parentPostId, brandId }) =>
  (dispatch) => {
    const params = serializeJSONApiData(
      'phase-groups',
      {
        contentAccountId,
        uuid: attachmentId,
        parentPostId,
      },
      true
    )

    // manually add brand relationship since serializeJSONApiData only supports attributes
    const paramsWithRelationships = {
      ...params,
      data: {
        ...params.data,
        relationships: {
          brand: {
            data: {
              type: 'brand',
              id: brandId,
            },
          },
        },
      },
    }

    return postWorkflow({ params: paramsWithRelationships })
      .then((response) => {
        dispatch(loadWorkflow(response.data))
        return dispatch(workflowLoaded())
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default createWorkflow
